import { AccountGenderDefinition } from '@calm/evexia-web-sdk';
import createAccountApi from '@rhg/libs/api/create-account-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { queryKeys, useQuery } from '@rhg/libs/react-query';

export const gendersQueryOptions = {
    queryKey: () => [queryKeys.genders],
    queryFn: async function (
        getAccessTokenSilently: () => Promise<string>,
        isAuthenticated: boolean
    ) {
        if (!isAuthenticated) {
            return [];
        }
        const accountApi = createAccountApi(getAccessTokenSilently);

        const response = await accountApi.getGendersV1({});

        return (response.data.genders as AccountGenderDefinition[]) ?? [];
    },
    queryOptions: (isAuthenticated: boolean) => ({
        enabled: isAuthenticated,
        staleTime: 1000 * 60 * 60 * 8, // 8 hours
    }),
};
export function useGenders() {
    const { isAuthenticated, getAccessTokenSilently } = useAuth();
    const { queryKey, queryFn, queryOptions } = gendersQueryOptions;

    const { data, ...otherProps } = useQuery({
        queryKey: queryKey(),
        queryFn: async () => queryFn(getAccessTokenSilently, isAuthenticated),
        ...queryOptions(isAuthenticated),
    });
    return {
        genders: data ?? [],
        ...otherProps,
    };
}
